module.exports = __webpack_public_path__ + "static/media/icon_facebook.4bf7c6a7.svg";